import {API_URL} from "@/infrastructure/urls.js";
import {useLoadingBarStore} from "@/stores/LoadingBarStore.js";

// Счетчик активных загрузок
let activeDownloads = 0;

/**
 * Загружает изображение с сервера используя Bearer токен в заголовках
 * @param {string} url - URL изображения (без api_token)
 * @param {string} token - Bearer токен для авторизации
 * @returns {Promise<string>} - Blob URL для использования в src
 */
export async function loadImageWithAuth(url, token) {
    if (!token) {
        console.warn('Token is required for loading images')
        return null
    }

    const loadingBar = useLoadingBarStore();

    // Начинаем загрузку
    activeDownloads++;
    if (activeDownloads === 1) {
        loadingBar.start();
    }

    try {
        const response = await fetch(url, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })

        if (!response.ok) {
            throw new Error(`Failed to load image: ${response.status}`)
        }

        const blob = await response.blob()
        return URL.createObjectURL(blob)
    } catch (error) {
        console.error('Error loading image:', error)
        return null
    } finally {
        // Завершаем загрузку
        activeDownloads--;
        if (activeDownloads === 0) {
            loadingBar.finish();
        }
    }
}

/**
 * Очищает blob URL для освобождения памяти
 * @param {string} blobUrl - Blob URL созданный через URL.createObjectURL
 */
export function revokeBlobUrl(blobUrl) {
    if (blobUrl && blobUrl.startsWith('blob:')) {
        URL.revokeObjectURL(blobUrl)
    }
}

/**
 * Кеш для blob URLs чтобы избежать повторных загрузок
 */
const imageCache = new Map()

/**
 * Загружает изображение с кешированием
 * @param {string} url - URL изображения
 * @param {string} token - Bearer токен
 * @returns {Promise<string>} - Blob URL
 */
export async function loadImageWithCache(url, token) {
    const cacheKey = `${url}_${token}`
    
    if (imageCache.has(cacheKey)) {
        return imageCache.get(cacheKey)
    }

    const blobUrl = await loadImageWithAuth(url, token)
    if (blobUrl) {
        imageCache.set(cacheKey, blobUrl)
    }
    
    return blobUrl
}

/**
 * Очищает весь кеш изображений
 */
export function clearImageCache() {
    imageCache.forEach(blobUrl => revokeBlobUrl(blobUrl))
    imageCache.clear()
}
